// extracted by mini-css-extract-plugin
export default {"content":"style_content__7fHNb","wrap":"style_wrap__8LlDj","list":"style_list__xvH1W","title":"style_title__TcSqE"};